import config from "../../config/app";
import axios from "axios";
import store from "../store/store";

const api = axios.create({
  baseURL: config.API_URL,
  withCredentials: false,
  headers: {
    Accept: "application/x.terran.v1+json",
    //'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  store.state.isLoading = true;
  return config;
});

api.interceptors.response.use(
  (res) => {
    store.state.isLoading = false;
    return res;
  },
  (res) => {
    store.state.isLoading = false;

    if (
      res.response.status === 401 &&
      res.response.data.message !== "You are detected as a robot!"
    ) {
      store.dispatch("logout");
      window.location.href = "/login";
    }

    return Promise.reject(res);
  }
);

function transformData(data) {
  return Object.entries(data)
    .map((x) => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`)
    .join("&");
}

export default {
  STATUS_200: 200,
  STATUS_403: 403,
  delete(url) {
    this.sethHeaders();

    return api.delete(url).then((result) => {
      return result;
    });
  },
  put(url, data) {
    this.sethHeaders(true);

    return api.put(url, transformData(data)).then((result) => {
      return result;
    });
  },
  post(url, data) {
    this.sethHeaders();

    return api.post(url, data).then((result) => {
      return result;
    });
  },
  get(...args) {
    this.sethHeaders();

    return api.get(...args).then((result) => {
      return result;
    });
  },
  clearHeaders() {
    api.defaults.headers.common["Authorization"] = "";
  },
  sethHeaders(isPut = false) {
    if (
      store.getters.isAuthenticated &&
      !api.defaults.headers.common["Authorization"]
    ) {
      var user = store.state.auth.user;
      api.defaults.headers.common["Authorization"] = `Bearer ${user.jwt.token}`;
    }

    api.defaults.headers.common["Content-Type"] = isPut
      ? "application/x-www-form-urlencoded"
      : "application/json";
  },
};
